module.exports = __webpack_public_path__ + "images/emoji/christmas_tree.95a208f10aacef503a0c.png";


//////////////////
// WEBPACK FOOTER
// ./resources/images/emoji/christmas_tree.png
// module id = nM69
// module chunks = 1